export default {
  APP_URL: process.env.VUE_APP_APP_URL,
  API_URL: process.env.VUE_APP_API_URL,
  SUPPORT_EMAIL: process.env.VUE_APP_SUPPORT_EMAIL,
  RECURLY_PUBLIC_KEY: process.env.VUE_APP_RECURLY_PUBLIC_KEY,
};
